import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';
import { GroupModel, UserModel } from './group.model';

export class OrganizationModel {
    organizationId:string;
    organizationName: string;
    description:string;
    isActive: boolean;
    users: UserModel[] = [];
    groups: GroupModel[] = [];    
    isSelected: boolean=false;
    deletedUsers?: UserModel[] = [];
    userActivityLog? :  UserActivityLogModel;
    logoFormat: string;
    logoImage: string;
    logoSize: number;
 }